import { render, staticRenderFns } from "./DoorphoneTestActivation.vue?vue&type=template&id=206bc760&scoped=true"
import script from "./DoorphoneTestActivation.vue?vue&type=script&lang=js"
export * from "./DoorphoneTestActivation.vue?vue&type=script&lang=js"
import style0 from "./DoorphoneTestActivation.vue?vue&type=style&index=0&id=206bc760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206bc760",
  null
  
)

export default component.exports